import AssessmentDetail from "pages/Courses/AssessmentDetails";
import CourseDetail from "pages/Courses/CourseDetail";
import Courses from "pages/Courses/Courses";
import Dashboard from "pages/Dashboards/Dashboard";
import InstructorProfile from "pages/Profile/InstructorProfile";
import SessionAttendance from "pages/TrainerSessions/SessionAttendance";
import SessionsList from "pages/TrainerSessions/SessionsList";

const routes = [
  {
    show: true,
    path: "/dashboard",
    name: "Dashboards",
    icon: "ni ni-shop text-deep-blue",
    component: <Dashboard />,
    layout: "/instructor",
    roles: ["ADMIN", "CHANNEL_PARTNER", "TRAINER"],
  },
  {
    show: false,
    path: "/profile",
    name: "Instructor Profile",
    icon: "ni ni-shop text-deep-blue",
    component: <InstructorProfile />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: true,
    path: "/my-courses",
    name: "My Courses",
    icon: "ni ni-hat-3 text-deep-blue",
    component: <Courses />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/my-courses/:id/details",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseDetail />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/course/:id/details/:assessmentId",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <AssessmentDetail />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: true,
    path: "/sessions",
    name: "Sessions",
    icon: "ni ni-calendar-grid-58 text-deep-blue",
    component: <SessionsList />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/sessions/view/:sessionId",
    name: "Sessions Details",
    icon: "ni ni-calendar-grid-58 text-deep-blue",
    component: <SessionAttendance />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
];
export default routes;
